import Auth from 'api/drivers/auth';

export default function signin(data) {
  return Auth.signin(data);
}
